(() => {
  const roots = document.querySelectorAll("[data-idp-prep]");
  if (!roots.length) return;

  const machineScale = {
    small: "Equipo compacto y maniobrable para superficies reducidas y perímetros",
    medium: "Máquina de formato medio con anchura y presión equilibradas",
    large: "Equipo de alta productividad, preferentemente autopropulsado o con asistencia al avance"
  };

  const supportNotes = {
    concrete: "Confirmar resistencia, dureza, humedad, lechada y contaminación del hormigón.",
    asphalt: "Realizar prueba previa: temperatura, ligante y granulometría pueden limitar la intensidad del tratamiento.",
    terrazzo: "Identificar composición, estado de juntas y secuencia abrasiva compatible con el terrazo o la piedra.",
    coated: "Comprobar espesor, adherencia, elasticidad y composición de la capa existente antes de elegir el útil."
  };

  const recommendations = {
    grinding: {
      title: "Diamantado mecánico con aspiración conectada",
      reason: "Proceso regulable para retirar lechada, capas finas y pequeñas irregularidades, dejando un rayado homogéneo antes de imprimar.",
      tool: "Diamante metálico; liga y grano definidos tras comprobar dureza y abrasividad",
      dust: "Extractor industrial conectado al carenado y dimensionado al caudal de la máquina"
    },
    blasting: {
      title: "Granallado en circuito cerrado",
      reason: "Solución productiva para limpiar y generar un perfil abierto y uniforme en superficies extensas sin introducir agua en el soporte.",
      tool: "Granalla, caudal y velocidad de avance ajustados mediante una prueba de patrón",
      dust: "Extractor de alto caudal, separación de finos y conexiones estancas compatibles"
    },
    removal: {
      title: "Rascado mecánico y preparación posterior",
      reason: "La cuchilla levanta revestimientos flexibles o elásticos por cizallamiento; después se elimina el adhesivo residual y se homogeneiza la base.",
      tool: "Cuchilla, anchura y ángulo de ataque seleccionados según material, adherencia y resistencia del soporte",
      dust: "Recogida separada de la capa retirada y aspiración conectada durante la limpieza del adhesivo residual"
    },
    milling: {
      title: "Fresado controlado seguido de regularización",
      reason: "Intervención de mayor profundidad para reducir cotas, retirar material grueso o sanear una superficie deteriorada antes del acabado de preparación.",
      tool: "Tambor y herramienta configurados para la profundidad por pasada; diamantado posterior si procede",
      dust: "Extractor de alta capacidad y gestión del residuo grueso generado por el fresado"
    },
    polishing: {
      title: "Refinado progresivo mediante pulido",
      reason: "Secuencia abrasiva escalonada para reducir el rayado anterior y controlar exposición, claridad y acabado del hormigón, terrazo o piedra compatible.",
      tool: "Secuencia de abrasivos metálicos, híbridos o de resina validada sobre una zona de muestra",
      dust: "Extracción en seco o gestión de lodo en húmedo definida antes de comenzar"
    },
    highSpeed: {
      title: "Abrillantado de alta velocidad",
      reason: "Proceso de mantenimiento para recuperar claridad y uniformidad sobre protectores compatibles. No sustituye al diamantado ni genera perfil de anclaje.",
      tool: "Disco compatible con el protector, ajustado mediante una prueba para evitar marcas y sobrecalentamiento",
      dust: "Limpieza previa completa y control de partículas según la máquina y el disco seleccionado"
    },
    multicutter: {
      title: "Multicorte diamantado de profundidad controlada",
      reason: "Cortes paralelos para rebajar material duro, retirar capas fuertemente adheridas o ejecutar canales con mayor precisión que un fresado convencional.",
      tool: "Tambor de discos, separación y profundidad definidos según el espesor y la resistencia del material",
      dust: "Extracción de alta capacidad o gestión de lodo cuando el equipo esté configurado para corte húmedo"
    }
  };

  roots.forEach((root) => {
    if (root.dataset.idpPrepReady === "true") return;
    root.dataset.idpPrepReady = "true";

    const state = { support: "concrete", goal: "open", intensity: "medium", area: "medium" };
    const fields = {
      title: root.querySelector("[data-idp-prep-result-title]"),
      reason: root.querySelector("[data-idp-prep-result-reason]"),
      machine: root.querySelector("[data-idp-prep-result-machine]"),
      tool: root.querySelector("[data-idp-prep-result-tool]"),
      dust: root.querySelector("[data-idp-prep-result-dust]"),
      check: root.querySelector("[data-idp-prep-result-check]")
    };

    const selectRecommendation = () => {
      if (state.goal === "polish") return state.intensity === "light" ? "highSpeed" : "polishing";
      if (state.goal === "level") return state.intensity === "aggressive" ? "multicutter" : "milling";
      if (state.goal === "remove") {
        if (state.support === "coated" && state.intensity !== "aggressive") return "removal";
        return state.intensity === "aggressive" && state.support !== "asphalt" ? "multicutter" : "milling";
      }
      if (state.support === "terrazzo") return "grinding";
      if (state.area === "large" && state.intensity !== "light") return "blasting";
      return "grinding";
    };

    const render = () => {
      const method = recommendations[selectRecommendation()];
      fields.title.textContent = method.title;
      fields.reason.textContent = method.reason;
      fields.machine.textContent = machineScale[state.area];
      fields.tool.textContent = method.tool;
      fields.dust.textContent = method.dust;
      fields.check.textContent = `${supportNotes[state.support]} Verificar uniformidad, limpieza y compatibilidad con el sistema posterior.`;
    };

    root.querySelectorAll("[data-idp-prep-group]").forEach((group) => {
      const key = group.dataset.idpPrepGroup;
      group.querySelectorAll("button[data-value]").forEach((button) => {
        button.addEventListener("click", () => {
          state[key] = button.dataset.value;
          group.querySelectorAll("button[data-value]").forEach((item) => {
            const active = item === button;
            item.classList.toggle("is-active", active);
            item.setAttribute("aria-pressed", String(active));
          });
          render();
        });
      });
    });

    root.querySelector("[data-idp-prep-contact]")?.addEventListener("click", () => {
      const selected = Array.from(root.querySelectorAll("[data-idp-prep-group]")).map((group) => {
        const active = group.querySelector("button.is-active");
        return active?.textContent.trim();
      });
      const message = [
        "Solicitud de estudio de maquinaria para preparación de pavimentos.", "",
        `Soporte: ${selected[0]}`, `Objetivo: ${selected[1]}`,
        `Intensidad: ${selected[2]}`, `Superficie: ${selected[3]}`, "",
        `Proceso orientativo: ${fields.title.textContent}`, "",
        "Quiero validar la configuración de máquina, útil y aspiración con IDP."
      ].join("\n");
      window.localStorage.setItem("idp_pending_contact_message", JSON.stringify({
        subject: "Estudio de maquinaria para preparación de pavimentos",
        body: message
      }));
    });

    render();
  });
})();
